import { oc } from '@orpc/contract'

export const base = oc.$route({ inputStructure: 'detailed' })
